import {SET_REDIRECT} from '../actions/types';

const initialState = {
    url: null,
};

export default function (state = initialState, action) {

    const {payload, type} = action

    switch (type) {

        case SET_REDIRECT:

            return {
                ...state,
                url: payload,
            };

        default:
            return state;
    }
}
